import type { CustomElementOptions } from 'vue';
import type { ChildElementOptions } from './childElementOptions';

export interface EConnectElementOptions {
  ssr: boolean;
  formAssociated: boolean;
  formSubmitter: boolean;
  customElementOptions?: CustomElementOptions;
  childElementOptions: Record<string, ChildElementOptions>;
  attributeEventMapping: Record<string, string[]>;
  /** If true, the base class will prune whitespace-only text nodes assigned to default slots. Default: true */
  trimDefaultSlotWhitespace?: boolean;
}

export const defaultElementOptions: EConnectElementOptions = {
  ssr: false,
  formAssociated: false,
  formSubmitter: false,
  trimDefaultSlotWhitespace: true,
  customElementOptions: {
    shadowRoot: true
  },
  attributeEventMapping: {},
  childElementOptions: {}
};
